// @ts-nocheck
// Recipe page (sections/main-recipe.liquid). The recipe is the sheet's content, same markup
// (snippets/vhp-recipe-body.liquid); its ticks, servings stepper, video and tabs are window.vhpRecipeBody and
// "Zum Meal Plan hinzufügen" is wired on the document, both in assets/vhp-recipe-sheet.js. Here: cooking mode, print,
// share and the feed's peek. Texts come from the section's JSON config ([data-vhp-recipe-config]).
(() => {
  'use strict';

  const root = document.querySelector('.vhp-main-recipe');
  const configEl = document.querySelector('[data-vhp-recipe-config]');
  if (!root || !configEl || root.dataset.recipeBound === '1') return;
  root.dataset.recipeBound = '1';

  let config = {};
  try {
    config = JSON.parse(configEl.textContent) || {};
  } catch (_) {}

  const body = root.querySelector('[data-vhp-recipe-body]');
  root.addEventListener('click', (event) => window.vhpRecipeBody?.click(event));

  /* ── WHAT HAPPENS ON THE RECIPE (docs/RECIPE_FUNNEL.md 0.4) ── */
  // recipe_use steps (assets/vhp-planner-events.js, once per browser and day each), non-subscribers: the recipe's head
  // on screen (open; on an article it sits under the deck), the video played, the ingredient list on screen (ings; its
  // tab is the second one), the end of the method on screen (end), servings changed, cook mode opened, "Fertig" there
  // (cook_done), shared, printed.
  const subscriber = (() => {
    try {
      return JSON.parse(document.getElementById('vhp-account-config')?.textContent || '{}').subscriber === true;
    } catch (_) {
      return false;
    }
  })();
  const use = (value) => {
    if (!subscriber) window.vhpPlannerEvents?.step('recipe_use', value);
  };
  if (body && 'IntersectionObserver' in window) {
    const seen = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          use(entry.target.dataset.vhpUse);
          seen.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -15% 0px' }
    );
    [
      [root.querySelector('.vrp-head'), 'open'],
      [body.querySelector('.vhp-recipe-ings'), 'ings'],
      [body.querySelector('[data-vhp-recipe-end]'), 'end'],
    ].forEach(([el, value]) => {
      if (!el) return;
      el.dataset.vhpUse = value;
      seen.observe(el);
    });
  }
  root.addEventListener('click', (event) => {
    const t = event.target instanceof Element ? event.target : null;
    if (t?.closest('[data-vhp-recipe-play]')) use('video');
    else if (t?.closest('[data-serv], [data-vhp-who-pick]')) use('serv');
  });
  // Her portion on the list (docs/PORTION_FIRST.md batch 1, assets/vhp-plan-goal.js applyPortion): once, when the
  // ingredient list is on screen in her amounts, whether the portion came first or the scroll.
  if (body) {
    const ings = body.querySelector('.vhp-recipe-ings');
    let yoursSent = false;
    const sendYours = () => {
      if (yoursSent || !ings || body.dataset.yours !== 'on') return;
      const r = ings.getBoundingClientRect();
      if (r.bottom <= 0 || r.top >= window.innerHeight * 0.85) return;
      yoursSent = true;
      use('ings_yours');
    };
    body.addEventListener('vhp:portion-applied', sendYours);
    if (ings && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => entry.isIntersecting && sendYours());
          if (yoursSent) io.disconnect();
        },
        { rootMargin: '0px 0px -15% 0px' }
      );
      io.observe(ings);
    }
  }

  // Zubereitung / Zutaten tabs and collapsible rows like the sheet; an anchor (#ingredients, #tools, …) opens its part.
  if (body && window.vhpRecipeBody?.enhance) {
    window.vhpRecipeBody.enhance(body);
    const revealHash = () => {
      const id = decodeURIComponent(window.location.hash.slice(1));
      if (window.vhpRecipeBody.reveal(body, id)) document.getElementById(id)?.scrollIntoView();
    };
    if (window.location.hash) revealHash();
    window.addEventListener('hashchange', revealHash);
  }

  /* ── COOKING MODE ── */
  // Shared cook mode (assets/vhp-cook.js), read from the page at the current servings. Ticks go both ways; "+ Plan"
  // sits in its top bar like in the sheet.
  root.querySelectorAll('[data-action="cooking-mode"]').forEach((el) => {
    el.addEventListener('click', (event) => {
      if (!window.vhpCook || !body) return;
      const { ingredients, steps, done } = window.vhpCook.read(body, 'sheet');
      if (!steps.length) return;
      event.preventDefault();
      let planBtn = null;
      const planSource = body.querySelector('[data-rs-plan]');
      if (planSource) {
        planBtn = planSource.cloneNode(true);
        planBtn.className = 'cook__plan';
        planBtn.textContent = window.vhpT('rsheet.plan_short');
      }
      use('cook');
      window.vhpCook.open({
        title: root.querySelector('h1')?.textContent?.trim() || '',
        source: 'page',
        rateId: body.dataset.productId,
        ingredients,
        steps,
        done,
        actions: [planBtn],
        // "Fertig": the planner card under the rating (docs/RECIPE_FUNNEL.md 3.1), and the step.
        plan: window.vhpPlanNext?.cookCard(body) || null,
        onDone: () => use('cook_done'),
        onClose: (ticked) => {
          const on = new Set(ticked);
          [...body.querySelectorAll('.vhp-recipe-ings__item')]
            .filter((row) => row.querySelector('.vhp-recipe-ings__name')?.textContent.trim())
            .forEach((row, i) => row.classList.toggle('is-on', on.has(i)));
        },
      });
    });
  });

  /* ── PRINT ── */
  const preparePrint = () => {
    const printUrl = document.getElementById('printRecipeUrl');
    if (printUrl) printUrl.textContent = window.location.href;
  };
  root.querySelectorAll('[data-action="print"]').forEach((el) => {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      use('print');
      preparePrint();
      window.print();
    });
  });
  window.addEventListener('beforeprint', preparePrint);
  // Print has everything: closed rows open for it and close again after (both tabs: print CSS).
  let printOpened = [];
  window.addEventListener('beforeprint', () => {
    printOpened = [...(body?.querySelectorAll('details:not([open])') || [])];
    printOpened.forEach((row) => (row.open = true));
  });
  window.addEventListener('afterprint', () => {
    printOpened.forEach((row) => (row.open = false));
    printOpened = [];
  });

  /* ── SHARE ── */
  const toast = (message) => {
    const node = document.createElement('div');
    node.className = 'rs-toast';
    node.textContent = message;
    node.setAttribute('role', 'status');
    document.body.appendChild(node);
    window.requestAnimationFrame(() => node.classList.add('is-in'));
    window.setTimeout(() => node.remove(), 1800);
  };

  const share = async () => {
    const url = window.location.href;
    const title = config.shareTitle || document.title;
    const text = title ? String(config.shareTemplate || '').replace('[title]', title) : config.shareFallback;
    // Native sharing first; a cancel is expected and ends here.
    if (navigator.share) {
      try {
        await navigator.share({ title, text, url });
        return;
      } catch (error) {
        if (error?.name === 'AbortError') return;
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      toast(config.shareCopied);
    } catch (_) {
      // No clipboard API here (embedded browsers, desktop apps): the old copy through a hidden field.
      toast(legacyCopy(url) ? config.shareCopied : config.shareNotPossible);
    }
  };
  const legacyCopy = (value) => {
    const field = document.createElement('textarea');
    field.value = value;
    field.setAttribute('readonly', '');
    field.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;';
    document.body.appendChild(field);
    field.select();
    let ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (_) {
      ok = false;
    }
    field.remove();
    return ok;
  };
  root.querySelectorAll('[data-action="share"]').forEach((el) => {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      use('share');
      share();
    });
  });

  /* ── LIKE ROW UNDER THE TITLE (2026-11-01, docs/RECIPE_CRO_ATTACK_PLAN.md P5) ──
        The heart saves the dish into the same likes the planner reads (assets/vhp-planner-likes.js); the line next to
        it counts to the three likes (one of them a main) that make a week, then links into the preview. */
  (() => {
    const row = document.querySelector('[data-vrp-like-row]');
    const btn = row?.querySelector('[data-vrp-like]');
    const text = row?.querySelector('[data-vrp-like-text]');
    const body = document.querySelector('.vrp [data-vhp-recipe-body]');
    const likes = window.vhpPlannerLikes;
    if (!row || !btn || !text || !body || !likes || body.dataset.plannable !== 'true') return;
    const id = String(body.dataset.productId || '');
    const dish = () => ({
      id,
      handle: body.dataset.handle,
      title: body.dataset.title,
      image: body.dataset.image || '',
      slot: body.dataset.slot,
      kcal: body.dataset.kcal,
      protein: body.dataset.protein,
      carbs: body.dataset.carbs,
      fat: body.dataset.fat,
      time: body.dataset.time,
    });
    const isLiked = (key) => likes.likeItems().some((item) => String(item.id) === String(key));
    const liked = () => isLiked(id);
    const fill = (template, vars) => String(template || '').replace(/\{(\w+)\}/g, (m, k) => (k in vars ? String(vars[k]) : m));
    // Hearts on the week row's cards (snippets/vhp-related-recipes.liquid), plannable dishes only.
    const more = row.querySelector('[data-vrp-like-more]');
    const cardHearts = [...document.querySelectorAll('[data-vrp-like-card]')]
      .map((heart) => ({ heart, card: heart.closest('.recipe-related__slide')?.querySelector('[data-vhp-recipe]') }))
      .filter(({ card }) => card && card.dataset.plannable === 'true' && Number(card.dataset.kcal) > 0);
    const cardDish = (d) => ({
      id: d.id,
      handle: d.handle,
      title: d.title,
      image: d.poster || d.image || '',
      slot: d.slot,
      kcal: d.kcal,
      protein: d.protein,
      carbs: d.carbs,
      fat: d.fat,
      time: d.time,
    });
    const paint = () => {
      cardHearts.forEach(({ heart, card }) => {
        const on = isLiked(card.dataset.id);
        heart.hidden = false;
        heart.setAttribute('aria-pressed', String(on));
        heart.classList.toggle('is-on', on);
      });
      const on = liked();
      btn.setAttribute('aria-pressed', String(on));
      btn.classList.toggle('is-on', on);
      btn.querySelector('[data-vrp-like-label]').textContent = on ? btn.dataset.tSaved : btn.dataset.tSave;
      const view = likes.weekView();
      const left = Math.max(0, likes.LIKE_READY - likes.likeCount());
      let line = '';
      if (view.ready) line = text.dataset.tReady;
      else if (left === 0 && view.needMain) line = text.dataset.tMain;
      else if (left === 1) line = text.dataset.tLeftOne;
      else line = fill(text.dataset.tLeftOther, { n: left });
      text.textContent = line;
      text.classList.toggle('is-ready', Boolean(view.ready));
      // Only once this dish is liked (Maxim, 11-01): the link is the next step after the first like, not a second ask.
      if (more) more.hidden = !on || Boolean(view.ready) || !cardHearts.length;
      row.hidden = false;
    };
    const pop = (el) => {
      if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
      el.classList.remove('is-pop');
      void el.offsetWidth;
      el.classList.add('is-pop');
    };
    cardHearts.forEach(({ heart, card }) => {
      heart.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (isLiked(card.dataset.id)) likes.removeLike(card.dataset.id);
        else {
          likes.addLike(cardDish(card.dataset));
          window.vhpTrack?.('recipe_like', { source: 'week_row' });
        }
        paint();
        pop(heart);
      });
    });
    more?.addEventListener('click', (event) => {
      const target = document.getElementById('recipe-related-heading');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      window.vhpTrack?.('recipe_like_more', {});
    });
    btn.addEventListener('click', () => {
      if (liked()) likes.removeLike(id);
      else {
        likes.addLike(dish());
        window.vhpTrack?.('recipe_like', { source: 'page_heart' });
      }
      paint();
      pop(btn);
    });
    window.addEventListener('vhp:likes-changed', paint);
    window.addEventListener('pageshow', paint);
    paint();
  })();

  /* ── PINTEREST ARRIVALS (2026-11-01, docs/RECIPE_CRO_ATTACK_PLAN.md, longer term): the week card speaks to the pin. */
  (() => {
    if (!/pinterest\./i.test(document.referrer || '')) return;
    const caption = document.querySelector('.vrp [data-vhp-next-caption]');
    if (caption?.dataset.tPin) caption.textContent = caption.dataset.tPin;
  })();

  /* ── RECIPE VIDEO AUTOPLAY (2026-11-01, Maxim: the deck above the article is retired, the recipe's own video plays
        once it is on screen. 2026-11-03 (Maxim): always muted, our own controls with a "Ton an" pill) ── */
  (() => {
    const wrap = document.querySelector('.vrp [data-vhp-recipe-video]');
    if (!wrap || !('IntersectionObserver' in window)) return;
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    if (navigator.connection?.saveData) return;
    const seen = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        seen.disconnect();
        window.vhpRecipeBody?.startVideo?.(wrap, { muted: true });
      },
      { threshold: 0.5 }
    );
    seen.observe(wrap);
  })();

  /* ── OPENED IN THE SWIPE FEED ── */
  // The recipe is a sheet under the deck (snippets/vhp-recipe-entry.liquid); its peeking top scrolls it up.
  document.querySelector('[data-vhp-entry-peek]')?.addEventListener('click', (event) => {
    const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    // Recipe first (sections/main-recipe.liquid): the recipe is already at the top, so the peek leads back up to the
    // deck in one jump (a smooth scroll over the booting deck stalls halfway).
    if (event.currentTarget.getBoundingClientRect().top < 8) {
      const html = document.documentElement;
      const was = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      window.scrollTo(0, 0);
      html.style.scrollBehavior = was;
      window.vhpTrack?.('recipe_entry_deck', {});
      return;
    }
    event.currentTarget.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    window.vhpTrack?.('recipe_entry_peek', {});
  });
})();
